import React from "react";
import NavBarSmallScreen from "./NavBarSmallScreen";
import NavBarLargeScreen from "./NavBarLargeScreen";
import { useMediaQuery } from 'react-responsive';

const MainNavBar = () => {
  const isSmallScreen = useMediaQuery({ maxWidth: 767 }); // Adjust the breakpoint as needed

  return (
    <div>
      {isSmallScreen ? <NavBarSmallScreen /> : <NavBarLargeScreen />}
  
    </div>
  );
};

export default MainNavBar;
